module.exports = __webpack_public_path__ + "static/img/cp_ljfl_logo.30ae422.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/cp_ljfl_logo.png
// module id = oiKp
// module chunks = 0